import React from 'react';
import { Map } from 'immutable';
import Grid from '@mui/material/Grid';
import { Typography } from '@mui/material';
import { basicValidator } from '../../../core/util';
import Form from '../../../components/Form';
import SplitView from '../../../templates/SplitView';
import InfoFrame from '../../../components/InfoFrame';
import GridInput from '../../../components/form/GridInput';
import SubmitButton from '../../../components/form/SubmitButton';

function validator(formState) {
  if (formState.get('senha') !== formState.get('confirmacao')) {
    return Map({ confirmacao: 'Confirmação está diferente da senha' });
  }

  return basicValidator(formState, {
    senha: 'Insira uma senha',
    confirmacao: 'Digite a senha novamente',
  });
}

function ChangeEmailView(props) {
  const {
    view,
    isSaving,
    formState,
    changeEmail,
    isValidating,
    confirmationData,
  } = props;
  const message = confirmationData.get('message');
  const newEmail = confirmationData.get('novoEmail');

  return (
    <SplitView
      loading={isValidating}
      contextImage={{
        lg: 6,
        width: 400,
        alt: 'Participe',
        src: '/img/applets/confirmar-novo-email.svg',
      }}
    >
      {!message ? (
        <Form view={view} validator={validator}>
          {newEmail && (
            <>
              <Typography align="center" variant="h6">
                <b>Novo Email</b>
              </Typography>
              <Typography align="center" variant="h6">
                <i>{newEmail}</i>
              </Typography>
            </>
          )}
          <InfoFrame
            style={{ marginLeft: '16px', marginRight: '16px' }}
            text={`
              Para finalizar, cadastre uma senha segura. Pode ser sua senha
              atual ou uma nova.
            `}
          />
          <Grid container>
            <GridInput
              name="senha"
              label="Nova Senha"
              type="password"
              variant="outlined"
              autoComplete="off"
            />
            <GridInput
              name="confirmacao"
              label="Confirmação da nova senha"
              type="password"
              variant="outlined"
            />
            <Grid style={{ margin: '16px 0px' }} size={12}>
              <SubmitButton
                disabled={isValidating}
                loading={isSaving}
                onClick={() =>
                  changeEmail(confirmationData.get('codigo'), formState)
                }
              >
                Confirmar
              </SubmitButton>
            </Grid>
          </Grid>
        </Form>
      ) : (
        <Typography variant="h6" align="center">
          {message}
        </Typography>
      )}
    </SplitView>
  );
}

export default ChangeEmailView;
